import React from "react";
import "./ReadonlyPaymentField.scss";
const ReadonlyPaymentField = () => {
  return <div>ReadonlyPaymentField</div>;
};

export { ReadonlyPaymentField };
